<template>
  <div
    class="ab_hero"
    :class="{ 'no-events': aaLength === 1 }"
  >
    <HaPosition :position="spot.position" />

    <div class="ab_a-actions-wrapper gw_hvr gw_hvr_pointer_coarse_disabled">
      <div
        class="ab_a-actions"
        :style="
          l_open
            ? `height:${aaLength * 1.5}rem;
               transition:0.3s;
               --ha-action-hovered-clr-back: var(--clr-black-1-3);
               `
            : 'height: 1.5rem; transition:0.22s'
        "
        @click.stop="toggle"
      >
        <HaActionMetrics
          v-for="(action, aIdx) in l_available_actions"
          :key="`${aIdx}_${action.code}`"
          :style="`${
            l_open
              ? `top:0px;
                 --ha-aa-chart-opacity:1;
                 --ha-aa-selected-background:transparent`
              : `top:-${aIdx * 1.5}rem;`
          }`"
          :action="action"
          :open="l_open"
          :hasMetrics="!!action.correctness"
          :isNa="action.correctness === 'na'"
          :hasEv="!!action.ev"
          :showBetsIn="showBetsIn"
          :bettingInfo
        />
      </div>
      <div
        v-if="sizeMode !== 'C' && aaLength > 1"
        class="csst csst_nm ab_icon-opener gw_hvr_content gw_btn-r1"
        style="--padding: 0; --height: 1.25rem"
      >
        <div
          :class="{ rotated_180_before: l_open }"
          class="mdi mdi-chevron-down icon_btns transition_03"
          @click.stop="toggle"
        ></div>
        <div
          class="csst_content text-nowrap clr-white"
          :style="`position: absolute; top: -0.25rem; right: 1.5rem;`"
        >
          {{ l_open ? $t('tooltips.hide') : $t('tooltips.show') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HaPosition from '@/components/AnalyzeStreetBlocks/HaPosition'
import HaActionMetrics from '@/components/AnalyzeStreetBlocks/HaActionMetrics'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'HaHero',
  components: {
    HaPosition,
    HaActionMetrics,
  },
  mixins: [format_mix],
  props: {
    spot: Object,
    sizeMode: { default: () => 'L' },
    open: Boolean,
    showBetsIn: String,
    showEvIn: String,
  },
  emits: ['register:open', 'update:open'],
  data() {
    return {
      l_open: false,
    }
  },
  created() {
    if (this.l_available_actions.length > 1) {
      this.$emit('register:open', { id: this.spot.id, open: false })
    }
  },
  methods: {
    toggle() {
      this.l_open = !this.l_open
      this.$emit('update:open', { id: this.spot.id, open: false })
    },
    getResColor(action) {
      return action?.correctness_group?.color
    },
  },
  computed: {
    aaLength() {
      return this.spot.available_actions.length
    },
    l_available_actions() {
      const res = (this.spot?.available_actions || []).filter(aa =>
        this.sizeMode === 'C' ? aa.is_selected : true,
      )
      return res
    },
    bettingInfo() {
      return { showEvIn: this.showEvIn, pot: this.spot.pot }
    },
  },
  watch: {
    open(bool) {
      if (this.l_open !== bool) {
        this.l_open = bool
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.ab {
  &_hero {
    position: relative;
    display: flex;
  }
  &_icon-opener {
    font-size: 1.25rem;
    z-index: 14;
    position: absolute;
    top: 0.125rem;
    transition: 0.3s;
    right: 0;
    color: var(--clr-grey-2);
  }
  &_a-actions-wrapper {
    width: 100%;
  }
  &_a-actions {
    width: 100%;
    position: relative;
    flex-direction: column;
    display: flex;
    overflow: hidden;
    &_action {
      cursor: pointer;
      width: 100%;
      position: relative;
      display: flex;
      font-weight: 400;
      flex-shrink: 0;
      min-height: 1.5rem;
      height: 1.5rem;
      transition: 0.2s;
      height: 1.5rem;
      color: var(--ha-aa-color);
    }
  }
  &_a-action-metrics {
    display: flex;
    transition: 0.4s;
    text-align: right;
    z-index: 2;
    &_fre {
      width: 3rem;
    }
    &_ev {
      width: 5rem;
    }
    &_na {
      width: 3rem;
    }
  }
}
</style>
